import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { pxToRem } from '../../../../utils';
var chatItemStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      position: 'relative'
    }, (!p.attached || p.attached === 'top') && {
      paddingTop: pxToRem(16)
    }, {}, (p.attached === 'bottom' || p.attached === true) && {
      paddingTop: pxToRem(2)
    }, {
      paddingBottom: 0
    });
  },
  gutter: function gutter(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables;
    return Object.assign(_defineProperty({
      position: 'absolute',
      marginTop: v.gutterMargin
    }, p.contentPosition === 'end' ? 'right' : 'left', 0), (p.attached === 'bottom' || p.attached === true) && {
      display: 'none'
    });
  },
  message: function message(_ref3) {
    var p = _ref3.props,
        v = _ref3.variables;
    return {
      position: 'relative',
      "float": p.contentPosition === 'end' ? 'right' : 'left',
      marginLeft: v.messageMargin,
      marginRight: v.messageMargin
    };
  }
};
export default chatItemStyles;